import _ from 'lodash'

export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.StackContent.components.ExportsContent'

export const ANIMATED_PROGRESS_BARS = ['SCHEDULED', 'ENQUEUED', 'PROCESSING', 'DOWNLOADING']

// JOB CONSTANTS
export const TYPES = {
    XLS: 'XLS',
    PDF: 'PDF',
}

export const TASK_STATES = {
    SCHEDULED: 'SCHEDULED',
    ENQUEUED: 'ENQUEUED',
    PROCESSING: 'PROCESSING',
    FAILED: 'FAILED',
    SUCCEEDED: 'SUCCEEDED',
    DOWNLOADING: 'DOWNLOADING',
    DELETED: 'DELETED',
}

export const TASK_PRIORITIES = {
    DOWNLOADING: 0,
    SUCCEEDED: 1,
    FAILED: 2,
    PROCESSING: 3,
    SCHEDULED: 4,
    ENQUEUED: 5,
}

// ACTION CREATOR CONSTANTS
export const EXPORTS_INIT_LOAD = 'EXPORTS_INIT_LOAD'
export const EXPORTS_SET_LOADING_TRUE = 'EXPORTS_SET_LOADING_TRUE'
export const EXPORTS_SET_LOADING_FALSE = 'EXPORTS_SET_LOADING_FALSE'
export const EXPORTS_SET_LOADED_TRUE = 'EXPORTS_SET_LOADED_TRUE'

export const EXPORTS_CREATE_PDF_TASK = 'EXPORTS_CREATE_PDF_TASK'
export const EXPORTS_CREATE_PDF_TASK_REQUEST = (module, id) =>
    `EXPORTS_CREATE_${_.toUpper(module)}_${id}_PDF_TASK_REQUEST`

export const EXPORTS_CREATE_XLS_TASK = 'EXPORTS_CREATE_XLS_TASK'
export const EXPORTS_CREATE_XLS_TASK_REQUEST = (module, id) =>
    `EXPORTS_CREATE_${_.toUpper(module)}_${id}_XLS_TASK_REQUEST`

export const EXPORTS_GET_TASK_STATUS = 'EXPORTS_GET_TASK_STATUS'
export const EXPORTS_GET_TASK_STATUS_REQUEST = (jobId) => `EXPORTS_GET_TASK_${jobId}_STATUS_REQUEST`

export const EXPORTS_GET_TASKS_STATUS_REQUEST = 'EXPORTS_GET_TASKS_STATUS_REQUEST'

export const EXPORTS_GET_TASK_FILE = 'EXPORTS_GET_TASK_FILE'
export const EXPORTS_GET_TASK_FILE_REQUEST = (jobId) => `EXPORTS_GET_TASK_${jobId}_FILE_REQUEST`

export const EXPORTS_TASK_RECEIVED = 'EXPORTS_TASK_RECEIVED'
export const EXPORTS_TASK_CHANGE = 'EXPORTS_TASK_CHANGE'

export const EXPORTS_JOB_ADD_WATCHER = 'EXPORTS_JOB_ADD_WATCHER'
export const EXPORTS_JOB_REMOVE_WATCHER = (jobId) => `EXPORTS_JOB_${jobId}_REMOVE_WATCHER`

export const EXPORTS_TASK_REMOVE = (jobId) => `EXPORTS_TASK_${jobId}_REMOVE`

// POST MESSAGE CONSTANTS
export const WS_EXPORTS_TASK_RECEIVED = 'WS_EXPORTS_TASK_RECEIVED'
export const WS_EXPORTS_REMOVE_TASK = 'WS_EXPORTS_REMOVE_TASK' // also from old stack
export const WS_ENTITY_STACK_ADD_NOTIFICATION = 'WS_ENTITY_STACK_ADD_NOTIFICATION'
export const WS_ENTITY_STACK_REMOVE_NOTIFICATION = 'WS_ENTITY_STACK_REMOVE_NOTIFICATION'
export const WS_EXPORTS_SET_LOADED_TRUE = 'WS_EXPORTS_SET_LOADED_TRUE'
export const WS_EXPORTS_SET_LOADING_TRUE = 'WS_EXPORTS_SET_LOADING_TRUE'
export const WS_EXPORTS_SET_LOADING_FALSE = 'WS_EXPORTS_SET_LOADING_FALSE'

// POST MESSAGE CONTANTS FROM OLD STACK
export const WS_EXPORTS_REMOVE_NOTIFICATION = 'WS_EXPORTS_REMOVE_NOTIFICATION'
export const WS_EXPORTS_DOWNLOADE_FILE = 'WS_EXPORTS_DOWNLOADE_FILE'
export const WS_EXPORTS_CREATE_PDF_TASK = 'WS_EXPORTS_CREATE_PDF_TASK'
export const WS_EXPORTS_CREATE_XLS_TASK = 'WS_EXPORTS_CREATE_XLS_TASK'
export const WS_EXPORTS_INIT_LOAD = 'WS_EXPORTS_INIT_LOAD'

// APP STATE
export const EXPORTS_UPDATE_APP_STATE = 'EXPORTS_UPDATE_APP_STATE'
